import { getAngularService, AngularServices } from '../../core';
export function isActiveSpeakerOfGroupCall(stream) {
    if (!stream)
        return false;
    const globalUi = getAngularService(AngularServices.GlobalUi);
    return stream.streamId === globalUi.ui.activeStreamId && stream.hasAudio;
}
